import { Link } from "react-router-dom";

export function LegalLinks() {
  return (
    <nav className="footlink" aria-label="Enlaces legales">
      <Link to="/legal/aviso-legal">Aviso legal</Link>
      <Link to="/legal/privacidad">Privacidad</Link>
      <Link to="/legal/cookies">Cookies</Link>
      <Link to="/legal/atribuciones">Atribuciones</Link>
    </nav>
  );
}
